const translations = {
  title: 'Plantillas',
  titleDetails: 'Detalles',
  titleEdit: 'Editar Plantillas',
  insertedAt: 'Creado en: ',
  updatedAt: 'Actualizado en: ',
  entity: 'Entidad',
  document: 'Documento',
  description: 'Descripción',
  docsGenerate: 'Documentos generados',
  docsHistory: 'Historial de Documentos',
  addNew: 'Agregar Nueva Plantilla',
  'input.addDocument': 'Agregar Documento',
  'input.isDisabled': 'Deshabilitar Plantilla',
  name: 'Nombre',
  modalTitle: 'Creando plantilla',
  modalTitle_edit: 'Editando plantilla',
  listTitle: 'Plantillas de documentos',
  addNewButton: 'Agregar Nuevo',
  exclusiveForChecklist: 'Exclusivo para el cuestionario (opcional)',
  exclusiveForPlaceType: 'Exclusivo para el tipo de destino (opcional)',
  type: 'Tipo'
}

export default translations
